import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { getIcon, iconCacheKey, loadIcon } from "../../icons/manager";
import { text } from "./helpers";

var root = $.from_html(`<span aria-hidden="true"></span>`);

export default function InlineIcon($$anchor, $$props) {
	$.push($$props, true);

	let selected = $.prop($$props, 'selected', 3, false),
		active = $.prop($$props, 'active', 3, false),
		pressed = $.prop($$props, 'pressed', 3, false),
		current = $.prop($$props, 'current', 3, false),
		className = $.prop($$props, 'className', 3, "");

	let loadedIcons = $.state($.proxy({}));
	let iconRequest = 0;
	const iconName = $.derived(() => text($$props.name));

	function iconState() {
		return {
			selected: selected(),
			active: active(),
			pressed: pressed(),
			current: current(),
			weight: $$props.weight
		};
	}

	function hasStateVariant() {
		return !!(selected() || active() || pressed() || current() || $$props.weight && $$props.weight !== "regular");
	}

	function icon() {
		if (!$.get(iconName)) return "";

		const nextState = iconState();
		const variantIcon = getIcon($.get(iconName), nextState) || $.get(loadedIcons)[iconCacheKey($.get(iconName), nextState)] || "";

		if (variantIcon) return variantIcon;

		return hasStateVariant()
			? getIcon($.get(iconName)) || $.get(loadedIcons)[iconCacheKey($.get(iconName))] || ""
			: "";
	}

	$.user_effect(() => {
		const nextName = $.get(iconName);

		if (!nextName) return;

		const nextState = iconState();
		const key = iconCacheKey(nextName, nextState);

		if (getIcon(nextName, nextState) || $.get(loadedIcons)[key]) return;

		const request = ++iconRequest;
		let active = true;

		void loadIcon(nextName, nextState).then((svg) => {
			if (!active || request !== iconRequest || !svg) return;

			$.set(loadedIcons, { ...$.get(loadedIcons), [key]: svg }, true);
			$$props.onIconLoad?.();
		});

		return () => {
			active = false;
		};
	});

	var fragment = $.comment();
	var node = $.first_child(fragment);

	{
		var consequent = ($$anchor) => {
			var span = root();

			$.html(span, icon, true);
			$.reset(span);
			$.template_effect(($0) => $.set_class(span, 1, $0), [() => $.clsx(`slex-icon ${className()}`.trim())]);
			$.append($$anchor, span);
		};

		var d = $.derived(() => icon());

		$.if(node, ($$render) => {
			if ($.get(d)) $$render(consequent);
		});
	}

	$.append($$anchor, fragment);
	$.pop();
}